/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { errorPrompt, prompt } from "./../../Control/Vue/Notifications/Prompts";
import { postUrlEncoded } from "../LegacyAxiosUtil";
import { TextEditor } from "./TextEditor";

export class StatusMessageEditor extends TextEditor {
	protected async onPrimaryClick(event: JQuery.Event): Promise<void> {
		event.preventDefault();

		if (this.loading) {
			return;
		}

		if (!this.element.find("textarea").val()) {
			await prompt(this.primaryButton.data("error-empty")).promise;
			this.element.find("textarea").focus();
			return;
		}

		this.loading = true;
		this.primaryButton.button("loading");

		const data = {
			text: String(this.element.find("textarea").val() ?? ""),
		};

		try {
			const response = await postUrlEncoded<{ success: boolean, message: string }>(this.primaryButton.data("url"), data);

			if (response.data.success) {
				window.location.reload();
			}
			else {
				errorPrompt(response.data.message);
			}
		}
		finally {
			this.primaryButton.button("reset");
			this.loading = false;
		}
	}
}
